import type { CreateMfaToken } from '@dynamic-labs/sdk-api-core';
import { type RegistrationResponseJSON } from '@simplewebauthn/browser';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

type ServerRegisterPasskeyParams = {
  createMfaToken?: CreateMfaToken;
  registration: RegistrationResponseJSON;
};

export const serverRegisterPasskey = async (
  { registration, createMfaToken }: ServerRegisterPasskeyParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.registerPasskey({
    environmentId: core.environmentId,
    passkeyRegisterRequest: {
      ...registration,
      createMfaToken,
      response: {
        ...registration.response,
        clientDataJson: registration.response.clientDataJSON,
      },
    } as Parameters<
      typeof apiClient.registerPasskey
    >[0]['passkeyRegisterRequest'],
  });

  return response;
};
